import { matchPath } from "react-router";
import { NavItemType } from "types/menu";

// ==============================|| MENU ITEM FINDER - RECURSIVE FUNCTION ||============================== //

/**
 * Recursively traverses menu items to find and return the current active menu item.
 * If a menu item matches the current pathname, it returns that item.
 *
 * @param {NavItemType[]} items - List of menu items.
 * @param {string} pathname - Current route pathname.
 * @returns {NavItemType | null} The matching menu item or null if not found.
 */
export function getCurrentNavItem(
  items: NavItemType[],
  pathname: string,
): NavItemType | null {
  for (const item of items) {
    // Check if the current menu item matches the pathname
    if (
      (item.link && matchPath({ path: item.link, end: false }, pathname)) ||
      item.url === pathname
    ) {
      return item;
    }

    // Recursively check child menus
    if (item.children?.length) {
      const childMatch = getCurrentNavItem(item.children, pathname);
      if (childMatch) {
        return childMatch;
      }
    }
  }
  return null;
}
